import React from 'react'
import { useHistory } from 'react-router-dom'

import { AccountsList, TransactionList } from '../../components'
import { BalanceChart } from '../../components/balance-chart'
import { Paths } from '../../config/routes'
import { usePixel } from '../../hooks/use-pixel'

export function Dashboard() {
    const history = useHistory()
    usePixel({ page: 'Dashboard' })

    const handleGoToAccount = (acc: any) => {
        history.push(
            `${Paths.ACCOUNTS}?asset=${acc.amount.currency}&account=${acc.id}`,
        )
    }

    return (
        <div className='grid grid-rows-dashboard-3 lg:grid-rows-dashboard-2 grid-cols-3 grid-flow-col gap-4 py-4'>
            <div className='col-span-3 row-span-1 '>
                <BalanceChart />
            </div>
            <div className='row-span-1 col-span-3 lg:col-span-2'>
                <TransactionList type='bank' />
            </div>
            <div className='row-span-1 col-span-3 lg:col-span-1'>
                <AccountsList
                    group={false}
                    onClick={handleGoToAccount}
                    fillVertical
                />
            </div>
        </div>
    )
}
